export const GET_FREE_GIFT_DATA_ENDPOINT = '/Catalog/GetFreeGiftPopup';
